<template>
  <div class="page" v-loading="listLoading">
    <el-form @submit.native.prevent label-width="100px">
      <el-row>
        <!-- <el-col :span="6">
          <el-form-item label="商品SpuId:">
            <el-input v-model="searchData.spuId" placeholder="请输入商品Id" clearable></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item label="商品名称:">
            <el-input v-model="searchData.proName" placeholder="请输入商品名称" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品品牌：">
            <el-input v-model="searchData.brandName" placeholder="请输入商品品牌" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品型号:">
            <el-input v-model="searchData.modelCode" placeholder="请输入型号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button type="primary" @click="searchFun">查询</el-button>
            <el-button @click="resetFun">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <div class="flex">
          <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
        </div>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      @selection-change="selectCurrentRow" style="width: 100%" border>
      <!-- <el-table-column type="selection" width="50" fixed align="center"></el-table-column> -->
      <!-- <el-table-column prop="spuId" label="SpuId" width="120" align="center"></el-table-column> -->
      <el-table-column prop="proName" label="商品名称" align="center" min-width="300"></el-table-column>
      <el-table-column prop="typeName" label="商品类型" min-width="120" align="center"></el-table-column>
      <el-table-column prop="brandName" label="商品品牌" min-width="120" align="center"></el-table-column>
      <!-- <el-table-column label="商家型号" prop="model" width="120" align="center"></el-table-column> -->
      <el-table-column width="200" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
            @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]">
    </el-pagination>
  </div>
</template>

<script>
import {
  GetKSAXCommodityLibrary
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      searchData: {
        spuId: null,
        proName: null,
        brandName: null,
        modelCode: null,
        pageIndex: 1, //页码
        pageSize: 10, //页长
      },
      total: 0,
      listLoading: false,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      tableList: [],
    };
  },
  created() {
    this.getSpusOnSale();
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
    }
  },
  methods: {
    copyBtn(item, index, row) {
      // this.$router.push(`/Product/ComManagement/CreateProduct?copyid=${row.spuId}`)
      this.$router.push(`/Product/AddEditSpu?copyid=${row.spuId}`)
    },
    searchFun() {
      this.searchData.pageIndex = 1;
      this.getSpusOnSale();
    },
    resetFun() {
      this.searchData = {
        spuId: null,
        proName: null,
        brandName: null,
        modelCode: null,
        pageIndex: 1, //页码
        pageSize: 10, //页长
      }
      this.getSpusOnSale();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.searchData.pageIndex = val;
      this.getSpusOnSale();
    },
    handleSizeChange(e) {
      this.searchData.pageSize = e;
      this.getSpusOnSale();
    },
    //获取商品列表
    getSpusOnSale() {
      this.listLoading = true;
      GetKSAXCommodityLibrary(this.searchData).then((res) => {
        if (res.data.success) {
          this.total = res.data.result.data.dataCount;
          this.tableList = res.data.result.data.data || [];
        } else {
          this.$message.error(res.data.msg)
        }
        setTimeout(() => {
          this.listLoading = false;
        }, 500)
      });
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
